import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import WhySearchSection from "./components/WhySearchSection";
import SafetySection from "./components/SafetySection";
import ArticlesSection from "./components/ArticlesSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import { faqItems } from "@/mocks/categories";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://vigorbuy.cfd";
const logoUrl = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg";

export default function Home() {
  return (
    <main>
      {/* ====== Schema.org JSON-LD: WebSite ====== */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "@id": `${siteUrl}/#website`,
            url: siteUrl,
            name: "VigorBuy Resource Hub",
            description: "Discover the latest VigorBuy Spreadsheet resources, product comparisons, buying guides, and safe shopping tips across 14 curated categories.",
            potentialAction: {
              "@type": "SearchAction",
              target: {
                "@type": "EntryPoint",
                urlTemplate: "https://kaspreadsheet.com/search?q={search_term_string}",
              },
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />

      {/* ====== Schema.org JSON-LD: FAQPage ====== */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "@id": `${siteUrl}/#faq`,
            mainEntity: faqItems.map((item) => ({
              "@type": "Question",
              name: item.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: item.answer,
              },
            })),
          }),
        }}
      />

      <Navbar />
      <HeroSection />
      <TrustBar />
      <CategoryGrid />
      <AboutSection />
      <WhySearchSection />
      <SafetySection />
      <ArticlesSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </main>
  );
}